let language = {
    // SHIPPING
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-TITLE": "运输:",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-MESSAGE-TITLE": "地址信息",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-SHIPPING-BOX-TITLE": "送货地址：",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-RECEIVER-BOX-TITLE": "收件人：",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-RECEIVER-BOX-CHANGE-BUTTON": "更改地址",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-RECEIVER-BOX-ERROR-TIPS": "输入的地址邮政编码与选定的国家/地区不匹配。",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BILLING-BOX-TITLE": "账单地址：",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BILLING-BOX-OWNER": "持有人：",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BILLING-BOX-OWNER-CHANGE-BUTTON": "更改地址",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX": "交付方式",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TITLE": "交付方式：",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME": "预计交货时间：",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME-PRODUCTION": "生产时间",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME-WORKING-DAY": "工作日",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME-TRANSPORTATION": "运输时间",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME-RECEIPT": "预计收货时间：",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-SHIPPING-FEE": "运费：",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-NOTE-TITLE": "注意：",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-NOTE-ITEM-1": `1.送货时间仅供客户参考，{{appName}}无法保证物流服务的送货标准。`,
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-NOTE-ITEM-2": `2.在偏远地区，交货时间比正常运输时间延长3-5天。`,
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BUTTON-CANCEL": "取消",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BUTTON-CONTINUE": "继续",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BUTTON-REVIEWANDPQY":"审核及付款",
    
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-NONE-CONTENT": "无",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-NOT-SUPPORT": "此订单的送货地址不在{{appName}}的服务覆盖范围内。",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-METHOD-NOT_SUPPORT": "使用的配送方式：{{shipmentMethod}}（所选的运输方式不适用于该国家或地区。）",
    
    // ORDER
    "DIRECT-CHECKOUT-ENTRY-ORDER-TITLE": "下单",
    "DIRECT-CHECKOUT-ENTRY-ORDER-MESSAGE-TITLE": "产品信息",
    "DIRECT-CHECKOUT-ENTRY-ORDER-PRODUCT-DESCRIPTION": "商品描述",
    "DIRECT-CHECKOUT-ENTRY-ORDER-TABLE-HEADER-QUANTITY": "数量",
    "DIRECT-CHECKOUT-ENTRY-ORDER-TABLE-HEADER-UNIT-PRICE": "单价",
    "DIRECT-CHECKOUT-ENTRY-ORDER-TABLE-HEADER-TOTAL-PRICE": "总价",
    "DIRECT-CHECKOUT-ENTRY-ORDER-BUTTON-BACK": "返回",
    "DIRECT-CHECKOUT-ENTRY-ORDER-BUTTON-CONTINUE": "继续",
    "DIRECT-CHECKOUT-ENTRY-ORDER-FOOTER-TOTAL": "总计：",
    // PAYMENT
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-TITLE": "支付",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-UNITED":"统一价格",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-MESSAGE-TITLE": "支付方式",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-TOTAL": "总计：",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-COUPON": "优惠码：",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-COUPON-BUTTON-REDEEM": "兑换",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-COUPON-TIPS-ONLY": "仅",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-COUPON-TIPS-ALLOWED": "每个订单允许一个优惠码",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-SUBTOTAL": "产品和服务费用：",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-TAX": "税费：",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-SHIPPING-FEE": "运费：",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-FOOTER-TOTAL": "总计：",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-BUTTON-BACK": "返回",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-BUTTON-PAYMENT": "支付",
    "DIRECT-CHECKOUT-ENTRY-MODAL-BUTTON-CANCEL": "取消",
    "DIRECT-CHECKOUT-ENTRY-MODAL-BUTTON-SAVE": "保存",
    "DIRECT-CHECKOUT-TITLE": "支付方式：",
    "DIRECT-CHECKOUT-SHIPMENT-METHOD": "EShopper发货方式：",
    "DIRECT-CHECKOUT-SHIPMENT-METHOD-TIPS": `(此运输方式不支持在{{appName}}中使用，您应在支付前更改它。)`,
    "DIRECT-CHECKOUT-INFO-PRICE": "价格",
    "DIRECT-CHECKOUT-INFO-PRODUCTS": "产品",
    "DIRECT-CHECKOUT-INFO-WEIGHT": "重量：",
    "DIRECT-CHECKOUT-INFO-TOTAL-WEIGHT": "总重量：",
    "DIRECT-CHECKOUT-INFO-PAYMENT-SUBTOTAL": "支付小计：",
    "DIRECT-CHECKOUT-INFO-PAYMENT-TAX": "支付税：",
    "DIRECT-CHECKOUT-INFO-PAYMENT-SHIPPING-FEE": "支付运费：",
    "DIRECT-CHECKOUT-INFO-PAYMENT-TOTAL": "支付总计：",
    "DIRECT-CHECKOUT-INFO-BUTTON-CANCEL": "取消",
    "DIRECT-CHECKOUT-INFO-BUTTON-PAYMENT": "支付",
    "DIRECT-CHECKOUT-INFO-BUTTON-BUTTON-CONFIRMPAY":"确认并付款",
    "DIRECT-CHECKOUT-INFO-PAYMENT-PREVIEW":"预览",
    // 免密支付
    "DIRECT-CHECKOUT-PAYMENT-AUTO-TIP": "为您的{{appName}}账户添加此主要付款方式。这将是我们用于将来交易的默认收费方式。",
    "DIRECT-CHECKOUT-PAYPAL-INTRO-TIP": "PayPal接受所有主要信用卡。您不需要PayPal账户即可使用此付款方式。",
     "DIRECT-CHECKOUT_PAYMENT_BANK_TRANSFER_DES":"若要付款，请点击\“{{payBtnText}}\”并按照转账指示进行操作。"
};

export { language }
